import { jsx as o, jsxs as r } from "react/jsx-runtime";
import { useTranslation as w, FieldLabel as B, centsToUnits as L } from "@systemeio/ui";
import { useState as V, useRef as F } from "react";
import { CurrencyBadge as G } from "../../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as O } from "../../../../../utils/get-amount-with-currency-symbol.mjs";
import { getPhysicalProductPricePlan as W } from "../../utils/get-physical-product-price-plan.mjs";
import { useLocaleContext as _ } from "../../../../../providers/use-locale-provider.mjs";
import { useOfferStore as q, usePhysicalProductStore as U } from "../../../../../store/index.mjs";
import { Options as z } from "./options.mjs";
import { QuantityPicker as E } from "./quantity-picker.mjs";
import { Slider as H } from "./slider/index.mjs";
import { useWatch as J } from "@systemeio/util";
const ae = ({ product: a }) => {
  const { currency: y, productVariants: b, images: P = [], name: S, stock: k, limitStock: N } = a, [l, m] = V([]), { setPricePlan: d, setFinalAmount: f } = q(), { locale: v } = _(), { quantity: n, setQuantity: u, productVariant: i, setProductVariant: g } = U(), { t: I } = w(), c = F(null), D = (s) => {
    var t;
    (t = c == null ? void 0 : c.current) == null || t.slickGoTo(s);
  }, p = (s, t) => {
    const e = W(s, t);
    e && (d(e), f(e.amount));
  }, C = (s) => {
    var t;
    if (g(s), s.image) {
      const e = [s.image, ...l.slice(1)];
      m(e), (t = c.current) == null || t.slickGoTo(0);
    }
    p(a, s);
  };
  J(a, (s) => {
    if (!s)
      d(void 0), f(void 0);
    else {
      const t = [...P], e = i ?? b[0];
      e && g(e), e != null && e.image && t.unshift(e.image), m(t), e && p(s, e);
    }
  });
  const h = (i == null ? void 0 : i.stock) ?? k ?? 0, Q = () => u(n + 1), T = () => u(n - 1), x = h > 0 && N ? h : void 0, A = !!x && n >= x, j = n <= 1;
  return /* @__PURE__ */ o("div", { className: "flex flex-col gap-3 sm:gap-5", children: /* @__PURE__ */ r("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ o(B, { label: I("public_pages_purchase.product") }),
    /* @__PURE__ */ r(
      "div",
      {
        className: "border-text-secondary/30 flex flex-col gap-3.5 rounded-lg border px-3.5 py-5",
        children: [
          i && /* @__PURE__ */ o(
            z,
            {
              product: a,
              activeVariant: i,
              changeActiveVariant: C
            }
          ),
          /* @__PURE__ */ o(
            E,
            {
              quantity: n,
              onIncrease: Q,
              onDecrease: T,
              disabledIncreaseButton: A,
              disabledDecreaseButton: j
            }
          ),
          /* @__PURE__ */ o(H, { goToSlide: D, ref: c, images: l }),
          /* @__PURE__ */ r("div", { className: "flex items-baseline justify-between gap-3", children: [
            /* @__PURE__ */ o("h2", { className: "min-w-0 flex-1 text-[14px] font-normal leading-5", children: S }),
            /* @__PURE__ */ r("div", { className: "flex shrink-0 items-baseline gap-2.5", children: [
              /* @__PURE__ */ o(G, { currency: y }),
              /* @__PURE__ */ o("span", { className: "text-[14px] font-semibold leading-5", children: O(
                L((i == null ? void 0 : i.price) ?? a.price),
                a.currency,
                v
              ) })
            ] })
          ] })
        ]
      }
    )
  ] }) });
};
export {
  ae as ProductCard
};
